import React from 'react';

import SmartLink from 'Shared/components/SmartLink';

import AsanaLogo from 'Shared/images/AsanaLogo.svg';
import AsanaTaskSmartMenu from '../SmartMenu/AsanaTaskSmartMenu';
import { SmartLinkLogo, SmartLinkContainer } from '../components';

type Props = {
  children: React.ReactNode;
};

const AsanaTaskLink = ({ children, ...restProps }: Props) => {
  const SmartLinkJsx = ({ children }) => {
    return (
      <SmartLink {...restProps} hasBadge>
        <SmartLinkLogo src={AsanaLogo} />
        {children}
      </SmartLink>
    );
  };

  return (
    <SmartLinkContainer contentEditable={false}>
      <AsanaTaskSmartMenu {...restProps}>
        <SmartLinkJsx>{children}</SmartLinkJsx>
      </AsanaTaskSmartMenu>
    </SmartLinkContainer>
  );
};

export default AsanaTaskLink;
